import React from 'react';
import {createRoot} from "react-dom/client";
import App from './js/App';
import {getLanguageAttr} from "./js/utils";
import {i18n} from "@lingui/core"
import {I18nProvider} from "@lingui/react"
import {en, pl} from "make-plural/plurals"
import {messages as plMessages} from './locale/pl/messages'
import {messages as enMessages} from './locale/en-US/messages'
import {messages as gbMessages} from './locale/en-GB/messages'
import css from 'bundle-text:./css/style.scss';
import SettingsProvider from "./js/providers/SettingsProvider";

if (typeof window !== 'undefined') {
    let style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
}


i18n.loadLocaleData({
    'pl': {plurals: pl},
    'en-US': {plurals: en},
    'en-GB': {plurals: en}
})

i18n.load({
    'pl': plMessages,
    'en-US': enMessages,
    'en-GB': gbMessages,
})


const container = document.getElementById('ulopolis-charts');

const language = getLanguageAttr(container, ['pl', 'en-US', 'en-GB']);
const source = container.getAttribute('data-source_id');
const settings_uri = container.getAttribute('data-settings_uri');


i18n.activate(language)

const root = createRoot(container);

root.render(
    <I18nProvider i18n={i18n}>
        <SettingsProvider source_id={source} settings_uri={settings_uri} language={i18n.locale}>
            <App source_id={source}
                 uri={container.getAttribute('data-uri')}
                 weight={container.getAttribute('data-weight')}
                 days={container.getAttribute('data-days')}/>
        </SettingsProvider>
    </I18nProvider>
);
